export default "/images/ce0d4e33490fd3b331559024f060cc1f.avif";